import * as React from 'react'
import { FC } from 'react'
import Box, { BoxProps } from '@mui/material/Box'
const Handshake: FC<BoxProps<'svg'>> = (props) => (
  <Box
    component={'svg'}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 48 48"
    {...props}
  >
    <style>{'.st1{fill:#002677}'}</style>
    <g id="Layer_1">
      <path
        d="M39.653 26.035a2.636 2.636 0 0 0-.676-1.1L23.651 9.608c-4.376-4.376-11.478-4.376-15.854 0-4.387 4.388-4.387 11.49 0 15.865l2.577 2.578c.115-.32.298-.619.55-.882l2.429-2.429a2.44 2.44 0 0 1 3.448 0c.95.951.95 2.497 0 3.448a2.44 2.44 0 0 1 3.448 0c.95.951.95 2.497 0 3.448a2.44 2.44 0 0 1 3.448 0c.95.951.95 2.497 0 3.448a2.44 2.44 0 0 1 3.448 0c.607.607.824 1.467.641 2.257a2.851 2.851 0 0 0 3.265-.516 2.814 2.814 0 0 0 0-3.963 2.814 2.814 0 0 0 3.963 0 2.814 2.814 0 0 0 0-3.963 2.814 2.814 0 0 0 3.963 0c.55-.539.814-1.26.814-1.982a2.9 2.9 0 0 0-.138-.882zm-17.927.802-.034-.035.091-.023-.057.058z"
        style={{
          fill: '#ff612b',
        }}
      />
      <path
        d="M40.203 9.608c-4.35-4.35-11.392-4.371-15.774-.072l-.004-.004-9.39 9.39c1.992 1.99 5.25 1.99 7.241 0l5.344-5.344 11.357 11.357c.321.32.55.687.676 1.1l.55-.562c4.387-4.375 4.387-11.477 0-15.865zM27.786 37.34c-.092.436-.31.848-.642 1.192l-2.428 2.429c-.95.95-2.509.95-3.448 0-.95-.94-.95-2.498 0-3.449-.95.951-2.509.951-3.448 0-.95-.939-.95-2.497 0-3.448-.95.951-2.509.951-3.448 0-.95-.939-.95-2.497 0-3.448-.95.951-2.509.951-3.448 0a2.394 2.394 0 0 1-.55-2.565c.115-.321.298-.619.55-.882l2.428-2.429a2.44 2.44 0 0 1 3.448 0c.951.95.951 2.497 0 3.448a2.44 2.44 0 0 1 3.448 0c.951.95.951 2.497 0 3.448a2.44 2.44 0 0 1 3.448 0c.951.95.951 2.497 0 3.448a2.44 2.44 0 0 1 3.448 0c.608.607.825 1.466.642 2.257z"
        className="st1"
      />
    </g>
  </Box>
)
export default Handshake
